import { useEffect } from "react";

const useAccessTokenUpdater = (getAccessTokenSilently) => {
  useEffect(() => {
    const updateAccessToken = async () => {
      try {
        const existingToken = localStorage.getItem("accessToken");
        if(existingToken){
          await getAccessTokenSilently({ cacheMode: "off"});
        }
      } catch (error) {
        console.error("Error updating access token:", error);
      }
    };

    // Call the function immediately on mount
    updateAccessToken();

    // Set up an interval to call it every 58 minutes
    const interval = setInterval(updateAccessToken, 58 * 60 * 1000);

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, [getAccessTokenSilently]);
};

export default useAccessTokenUpdater;
